import { useState, useEffect } from "react";

import "./product.css";
const Product = ({ product }) => {
  const [selectedWeight, setSelectedWeight] = useState(
    product.weightDetails[0]
  );

  useEffect(() => {
    setSelectedWeight(product.weightDetails[0]);
  }, [product]);

  return (
    <section>
      <div className="container products__container">
        <div className="product__box">
          <h2>{product.title}</h2>
          <div className="product__content">
            <div className="product__image">
              <div className="image">
                <img src={selectedWeight.image} alt="product images" />
              </div>
            </div>
            <div className="product__details">
              <div className="weights">
                {product.weightDetails.map((item) => {
                  return (
                    <div
                      key={item.id}
                      className={`weight__btn ${
                        item.id === selectedWeight.id ? "clicked" : null
                      }`}
                      onClick={() => setSelectedWeight(item)}
                    >
                      {item.weight}
                    </div>
                  );
                })}
              </div>
              <div className="packaging">
                {selectedWeight.packageType.map((item) => {
                  return (
                    <div key={item} className="package-type-container">
                      <div className="package-type-btn">
                        <div>{item.type}</div>
                      </div>
                      <div className="package-type-text">
                        <div>{item.value}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;
